import type { AvailableRuntime } from "@/stores/companion-store";

/** Runtimes the companion reports, minus the signed-out ones, by the ids the
 *  store uses. Rust keeps only the ones it can run. */
export function connectedRuntimeIds(
  runtimes: readonly AvailableRuntime[],
): string[] {
  return runtimes
    .filter((runtime) => runtime.logged_in !== false)
    .map((runtime) => runtime.runtime_id ?? runtime.type);
}
